import history from 'history/browser';

const INTENDED_URL_KEY = 'appcues:intended-url';

export const saveIntendedUrl = () => {
  const { pathname, hash, search } = history.location;
  const fullPath = `${pathname}${search}${hash}`;

  if (pathname !== '/') {
    sessionStorage.setItem(INTENDED_URL_KEY, fullPath);
  }
};

export const restoreIntendedUrl = () => {
  const { pathname } = history.location;
  const savedPath = sessionStorage.getItem(INTENDED_URL_KEY);

  sessionStorage.removeItem(INTENDED_URL_KEY);

  if (savedPath && pathname === '/') {
    history.replace(savedPath);
  }
};
